export default "__VITE_ASSET__BGd9HGBQ__"